import {Component, OnInit, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MenuItem} from 'primeng/primeng';
import {QFilterModel} from '../../../models/qfilter.model';
import {AnalysisSingleStoreOverviewComponent} from './analysis-single-store/analysis-single-store-overview.component';
import {AnalysisSingleStoreDistributionComponent} from './analysis-single-store-distribution/analysis-single-store-distribution.component';
import {AnalysisSingleStoreTrendComponent} from './analysis-single-store-trend/analysis-single-store-trend.component';
import {AnalysisSingleStoreRevenueComponent} from './analysis-single-store-revenue/analysis-single-store-revenue.component';
import {AnalysisPromoComponent} from './analysis-promo/analysis-promo.component';
import {SearchToolbarModelFactoryService} from '../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import {
  SearchToolbarDateFunction,
  SearchToolbarFactoryParameters,
  SearchToolbarFilterGrouping,
  SearchToolbarFilterWindow,
  SearchToolbarSection
} from '../../../models/search-toolbar-factory-parameters.model';
import {IndicatorsSearchToolbarModel} from '../../../models/indicators-search-toolbar-model.model';
import {AnalyticsService} from '../../../services/analytics/analytics.service';
import {ApiMethods, PermissionConfiguration} from '../../../models/permission.model';
import {PermsService} from '../../../services/utils/perms.service';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-analysis',
  templateUrl: './analysis.component.html',
  styleUrls: ['./analysis.component.css']
})




// Pagina 33
export class AnalysisComponent implements OnInit {
  @ViewChild(AnalysisSingleStoreOverviewComponent) overview: AnalysisSingleStoreOverviewComponent;
  @ViewChild(AnalysisSingleStoreDistributionComponent) distribution: AnalysisSingleStoreDistributionComponent;
  @ViewChild(AnalysisPromoComponent) promo: AnalysisPromoComponent;
  @ViewChild(AnalysisSingleStoreRevenueComponent) revenue: AnalysisSingleStoreRevenueComponent;
  @ViewChild(AnalysisSingleStoreTrendComponent) trend: AnalysisSingleStoreTrendComponent;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();

  activeIndex: number;
  items: MenuItem[];
  oldData: any;


  /********************** PERMESSI UTENTE *************************/

  // Abilita tab Panoramica
  public negoziAnalisiOverviewPerm: boolean;
  public negoziAnalisiOverviewPermCheck: PermissionConfiguration;

  // Abilita tab Albero
  public negoziAnalisiAlberoPerm: boolean;
  public negoziAnalisiAlberoPermCheck: PermissionConfiguration;

  // Abilita tab Trend
  public negoziAnalisiTrendPerm: boolean;
  public negoziAnalisiTrendPermCheck: PermissionConfiguration;

  // Abilita tab Distribuzione Temporale
  public negoziAnalisiDistPerm: boolean;
  public negoziAnalisiDistPermCheck: PermissionConfiguration;

  // Abilita tab Analisi Promo
  public negoziAnalisiPromoPerm: boolean;
  public negoziAnalisiPromoPermCheck: PermissionConfiguration;

  /****************************************************************/


  constructor(
    private tService: TranslateService,
    private svcAnalytics: AnalyticsService,
    private srvPerms: PermsService,
    private searchModelFactory: SearchToolbarModelFactoryService
  ) {
    this.negoziAnalisiOverviewPermCheck = {
      ms_base: 'koncentro-analytics',
      operation: 'negozi-analisi-overview',
      method: ApiMethods.GET
    };
    this.negoziAnalisiAlberoPermCheck = {
      ms_base: 'koncentro-analytics',
      operation: 'negozi-analisi-albero',
      method: ApiMethods.GET
    };
    this.negoziAnalisiTrendPermCheck = {
      ms_base: 'koncentro-analytics',
      operation: 'negozi-analisi-trend',
      method: ApiMethods.GET
    };
    this.negoziAnalisiDistPermCheck = {
      ms_base: 'koncentro-analytics',
      operation: 'negozi-analisi-dist',
      method: ApiMethods.GET
    };
    this.negoziAnalisiPromoPermCheck = {
      ms_base: 'koncentro-analytics',
      operation: 'negozi-analisi-promo',
      method: ApiMethods.GET
    };
  }

  ngOnInit() {
    this.activeIndex = 0;
    this.items = [];

    Observable.zip(
      this.srvPerms.check(this.negoziAnalisiOverviewPermCheck),
      this.srvPerms.check(this.negoziAnalisiAlberoPermCheck),
      this.srvPerms.check(this.negoziAnalisiTrendPermCheck),
      this.srvPerms.check(this.negoziAnalisiDistPermCheck),
      this.srvPerms.check(this.negoziAnalisiPromoPermCheck)
    ).subscribe (([negoziAnalisiOverview, negoziAnalisiAlberoPermCheck, negoziAnalisiTrendPermCheck,
                                  negoziAnalisiDistPermCheck, negoziAnalisiPromoPermCheck ]) => {
      console.log('PERMISSION');
      this.negoziAnalisiOverviewPerm = negoziAnalisiOverview ;
      this.negoziAnalisiAlberoPerm = negoziAnalisiAlberoPermCheck ;
      this.negoziAnalisiTrendPerm = negoziAnalisiTrendPermCheck ;
      this.negoziAnalisiDistPerm = negoziAnalisiDistPermCheck ;
      this.negoziAnalisiPromoPerm = negoziAnalisiPromoPermCheck ;


      this.tService.get([
        'store.overview',
        'store.revenue_tab',
        'store.trend_tab',
        'store.distribution',
        'store.promo'
      ]).subscribe(t => {
        this.initSearchToolbar();

        this.items.push(
          {
            label: t['store.overview'], command: () => {
              this.activeIndex = 0;
            }, disabled: !this.negoziAnalisiOverviewPerm
          },
          {
            label: t['store.revenue_tab'], command: () => {
              this.activeIndex = 1;
            }, disabled: !this.negoziAnalisiAlberoPerm
          },
          {
            label: t['store.trend_tab'], command: () => {
              this.activeIndex = 2;
            }, disabled: !this.negoziAnalisiTrendPerm
          },
          {
            label: t['store.distribution'], command: () => {
              this.activeIndex = 3;
            }, disabled: !this.negoziAnalisiDistPerm
          },
          {
            label: t['store.promo'], command: () => {
              this.activeIndex = 4;
            }, disabled: !this.negoziAnalisiPromoPerm
          }
        );

        for (let index in this.items) {
          if (!this.items[index].disabled) {
            this.activeIndex = +index;
            break;
          }
        }
      });
    });
  }

  private initSearchToolbar() {
    const searchParams: SearchToolbarFactoryParameters = new SearchToolbarFactoryParameters();
    searchParams.svcAnalytics = this.svcAnalytics;
    searchParams.dateFunctionType = SearchToolbarDateFunction.VaDates;
    searchParams.finestra = SearchToolbarFilterWindow.TwentyFive;
    searchParams.raggruppamento = SearchToolbarFilterGrouping.All;
    searchParams.disabledSections = [SearchToolbarSection.CardModes, SearchToolbarSection.Clusterlist,
      SearchToolbarSection.GroupTypes, SearchToolbarSection.Areas, SearchToolbarSection.Groups  ];


    this.searchModelFactory.buildSearchToolbarModel(searchParams).subscribe((model) => {
      this.searchModel = model;
    });
  }

  performFilter(data: QFilterModel) {

    const isDataEquals = JSON.stringify(this.oldData) === JSON.stringify(data);

    if (this.activeIndex === 0) {

      if (!isDataEquals) {
        this.revenue.resetData();
        this.trend.resetData();
        this.distribution.resetData();
        this.promo.resetData();
      }
      this.overview.searchValueTrend(data);

    } else if (this.activeIndex === 1) {

      if (!isDataEquals) {
        this.overview.resetData();
        this.trend.resetData();
        this.distribution.resetData();
          this.promo.resetData();
      }

      this.revenue.searchValueTrend(data);

    } else if (this.activeIndex === 2) {

      if (!isDataEquals) {
        this.overview.resetData();
        this.revenue.resetData();
        this.distribution.resetData();
          this.promo.resetData();
      }

      this.trend.searchValueTrend(data);

    } else if (this.activeIndex === 3) {

        if (!isDataEquals) {
            this.overview.resetData();
            this.revenue.resetData();
            this.trend.resetData();
            this.promo.resetData();
        }

        this.distribution.searchValueTrend(data);
    } else if (this.activeIndex === 4) {

        if (!isDataEquals) {
            this.overview.resetData();
            this.revenue.resetData();
            this.trend.resetData();
            this.distribution.resetData();
        }

        this.promo.searchValueTrend(data);
    }

    this.oldData = { ...data };
  }
}



// WEBPACK FOOTER //
// ./src/app/views/store/analysis/analysis.component.ts